<template>
  <div class="page order-center-page">
    <div class="page-content">
      <div class="page-menu">
        <div class="page-menu-item" @click="setActive(index, item.label)"
          :class="[formDate.menuActive == index ? 'page-menu-item-active' : '']" v-for="(item, index) in menuList"
          :key="index">
          {{ item.name }}({{ item.value }})
        </div>
      </div>
      <div class="order-center-search">
        <div class="box-input-search">
          <div :class="isShowSearch ? 'box-input-flex-wrap' : 'box-input-flex'">
            <el-button class="button-icon" :icon="isShowSearch ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"
              type="primary" @click="isShowSearch = !isShowSearch"></el-button>
            <el-select clearable v-model="formDate.CountryId" style="width: 140px" placeholder="国家" filterable
              autocomplete="off" @change="getQueryorderorg(1)">
              <el-option v-for="item in countryData" :key="item.id" :label="item.zhName" :value="item.id">
              </el-option>
            </el-select>
            <el-select v-if="isShowSearch" class="box-input-left-z" style="width: 140px" clearable
              v-model="formDate.VisaTypeId" placeholder="签证类型" @change="getQueryorderorg(1)">
              <el-option v-for="item in visaType" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-select clearable v-model="formDate.OrderStatus" style="width: 120px" placeholder="订单状态" filterable
              autocomplete="off" @change="handleChangeOrderStatus">
              <el-option v-for="item in orderStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

            <el-select clearable v-model="formDate.ApplcantStatus" style="width: 140px" placeholder="申请人状态"
              @change="getQueryorderorg(1)">
              <el-option v-for="item in selectStatus" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-if="isShowSearch" clearable v-model="formDate.OrderSource" style="width: 140px"
              placeholder="订单来源" @change="getQueryorderorg(1)">
              <el-option v-for="item in orderSourceList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

            <!-- <el-select clearable v-model="formDate.continentId" style="width: 280px" @change="getQuery" placeholder="下单时间">
              <el-option v-for="item in visaType" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select> -->

            <el-date-picker v-model="dateInfo" style="width: 260px" type="daterange" range-separator="至"
              start-placeholder="下单开始日期" end-placeholder="下单结束日期" @change="setDate" value-format="yyyy-MM-dd">
            </el-date-picker>

            <!-- <el-select v-model="productForm.areaId" placeholder="请选择领区">
                    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select> -->

            <!-- <el-input style="width: 140px;" v-model="formDate.name" placeholder="产品名称"></el-input> -->

            <el-select v-if="isShowSearch" class="box-input-left-z" style="width: 140px" clearable filterable
              v-model="formDate.MerchatId" placeholder="商户" @change="getQueryorderorg(1)">
              <el-option v-for="item in continent" :key="item.id" :label="item.companyName" :value="item.id">
              </el-option>
            </el-select>
            <el-select v-if="isShowSearch" class="box-input-left-z" style="width: 140px" clearable filterable
              v-model="formDate.AppIdLong" placeholder="应用" @change="getQueryorderorg(1)">
              <el-option v-for="item in appinfoList" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.typeName }}</span>
              </el-option>
            </el-select>

            <el-date-picker v-if="isShowSearch" v-model="PlanVisaDateTime" style="width: 260px" type="daterange"
              range-separator="至" start-placeholder="出签开始日期" end-placeholder="出签结束日期" @change="setPlanVisaDate"
              value-format="yyyy-MM-dd">
            </el-date-picker>

            <el-select v-if="isShowSearch" class="box-input-left-z" style="width: 140px" clearable filterable
              v-model="formDate.PayType" placeholder="支付方式" @change="getQueryorderorg(1)">
              <el-option v-for="item in orderPayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input style="width: 320px" clearable v-model="formDate.Key" placeholder="订单号、护照号、联系人姓名、手机号"></el-input>

            <div class="box-input-btn-wrap">
              <el-button v-preventReClick class="default btn-size"
                @click="getQueryorderorg(1); relatedOrdersId = 0">搜索</el-button>
              <el-button class="box-input-btn-cz" style="padding: 12px 10px " @click="reset">重置</el-button>
              <el-button class="box-input-btn-cz btn-size" @click="openAdd">快速下单</el-button>
              <!-- <el-button icon="el-icon-upload" circle  @click="openSelection" title="导入护照"></el-button> -->
              <el-dropdown @command="handleMultiple($event)">
                <el-button class="default btn-size" style="margin-left: 5px;">批量操作<i
                    class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">导入护照</el-dropdown-item>
                  <el-dropdown-item command="b">批量导入excel</el-dropdown-item>
                  <el-dropdown-item command="c">批量导出申请人</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div style="color: #303133;font-weight: bold;position: relative;top: -6px;">
          营收：<span style="color: #F56C6C"> ￥{{ saleAmount }}</span>，
          入境卡：<span style="color: #F56C6C">￥{{ entryCardAmount }}</span>，
          <span @click="handleStatusChange(10)" style="cursor: pointer;">提交中：<span style="color: #F56C6C;">{{
              visingCount }}</span>人，</span>
          <span @click="handleStatusChange(20)" style="cursor: pointer;">提交失败：<span style="color: #F56C6C;">{{
              failedCount }}</span>人，</span>
          <span @click="handleStatusChange(-5)" style="cursor: pointer;">今日待出：<span style="color: #F56C6C;">{{
              visaTodayCount }}</span>人，</span>
          <span @click="handleStatusChange(16)" style="cursor: pointer;">出签人数：<span style="color: #F56C6C;">{{
            suceedCount }}</span>人</span>
        </div>
        <div class="box-table order-center-table"
          :style="isShowSearch ? 'height: calc(100% - 160px);' : 'height: calc(100% - 100px);'">
          <el-table :data="orderOrgList" :row-key="getRowKeys" :expand-row-keys="expands" @expand-change="expandSelect"
            @row-click="clickTable" :header-cell-style="{
              backgroundColor: '#F2F4F7',
              color: '#333',
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '12px',
            }" style="width: 100%" v-loading="loading" :height="$store.state.product.screen ? '920px' : '570px'"
            :cell-style="cellStyleFn" :cell-class-name="cellClassName" ref="refTable">
            <el-table-column type="selection" width="55" v-if="selectionShow">
            </el-table-column>
            <el-table-column type="expand" width="30" style="height: auto" fit>
              <template slot-scope="outer">
                <div class="props-table-box">
                  <el-table v-loading="loadingOrder" :data="orderUserList" :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{
                      backgroundColor: '#F9F9F9',
                      color: '#333',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: '12px',
                    }">
                    <el-table-column label="完成率">
                      <template slot-scope="props">
                        <el-progress type="circle" define-back-color="#EAF3FF" :percentage="props.row.taskTable"
                          :width="60" :height="60" :stroke-width="6" :color="colors"
                          style="transform: scale(0.8)"></el-progress>
                      </template>
                    </el-table-column>
                    <el-table-column label="姓名/拼音">
                      <template slot-scope="props">
                        <span>{{ props.row.applicantName }}
                          {{ props.row.surnameEn }} {{ props.row.nameEn }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="性别">
                      <template slot-scope="props">
                        <span>{{ props.row.gender }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="身份类型">
                      <template slot-scope="props">
                        <span>{{ props.row.identityTypeName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="国籍">
                      <template slot-scope="props">
                        <span>{{ props.row.passportCountryName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="护照号">
                      <template slot-scope="props">
                        <span>{{ props.row.passportNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="申请状态">
                      <template slot-scope="props">
                        <span :style="setTopClass(props.row.status)">{{
                          props.row.statusName
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="出生日期">
                      <template slot-scope="props">
                        <span>{{
                          props.row.birthday && props.row.birthday.split(" ")[0]
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="护照签发日">
                      <template slot-scope="props">
                        <span>{{
                          props.row.passportIssue &&
                          props.row.passportIssue.split(" ")[0]
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="护照到期日">
                      <template slot-scope="props">
                        <span>{{
                          props.row.passportValidity &&
                          props.row.passportValidity.split(" ")[0]
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="签证页">
                      <template slot-scope="props">
                        <div v-if="!props.row.visaPage" @click="orderApplicantId = props.row.id">
                          <el-upload action="" :http-request="uploadVisapage">
                            <i class="iconfont icon-shangchuan visa-icon">上传</i>
                          </el-upload>
                        </div>
                        <i class="iconfont icon-search visa-icon" v-else @click="openFile(props.row.visaPage)">
                          查看</i>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="props">
                        <div class="edit-wrap">
                          <div class="edit-item">
                            <span class="lan"
                              @click="openElectron(outer.row, props.row.id, { page: outer.row.pageIndex, pageSize: outer.row.pageSize })">查看</span>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="table-pagination" style="background-color: #f9f9f9">
                    <el-pagination @current-change="currentPropsChange($event, outer.row)"
                      :current-page="outer.row.pageIndex" :page-size="outer.row.pageSize"
                      layout="total, prev, pager, next, jumper" :total="outer.row.pageTotal">
                    </el-pagination>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="支付-完成时间" min-width="120">
              <template slot-scope="scope">
                <div class="flex-center">
                  <img :src="scope.row.complateTime ? time2 : time1" class="time-line" />
                  <div class="time-text">
                    <p :title="`创建时间：${scope.row.createdTime || ''}`">
                      {{ scope.row.createdTime ? formatTime(scope.row.createdTime) : "--" }}
                    </p>
                    <p :title="`支付时间：${scope.row.paymentTime || ''}`">
                      {{ scope.row.paymentTime ? formatTime(scope.row.paymentTime) : "--" }}
                    </p>
                    <p :title="`完成时间：${scope.row.complateTime || ''}`">
                      {{ scope.row.complateTime ? formatTime(scope.row.complateTime) : "--" }}
                    </p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="orderNo" label="订单号" width="100">
              <template slot-scope="scope">
                <div>
                  <div>
                    {{ scope.row.orderNo }}
                  </div>
                  <div v-if="scope.row.orderSource == 1">
                    <el-button size="mini" @click="relatedOrdersFn(scope.row)"
                      style="transform: scale(0.8);">关联订单</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="paidAmount" label="订单金额" min-width="80">
              <template slot-scope="scope">
                {{ price(scope.row) }}
                <div v-if="scope.row.couponAmount" style="color: #ff5967">
                  优惠 {{ scope.row.couponAmount }}元
                </div>
                <div v-if="String(scope.row.tradeType)" :title="scope.row.tradeTypeName">
                  <div class="source-type" :style="{ background: setPaidAmountColor(scope.row), 'margin-right': 0 }">
                    <span v-if="orderPayList.findIndex(res => res.value == scope.row.tradeType) > -1">
                      {{orderPayList.find(res => res.value == scope.row.tradeType)?.text}}
                    </span>

                    <span v-else style="transform: scale(0.6);"> {{ scope.row.tradeTypeName }}</span>
                  </div>
                </div>
                <div v-if="scope.row.orderSource == 1">
                  <el-link type="primary" @click.stop="openChangePrice(scope.row)"
                    icon="el-icon-edit-outline"></el-link>
                </div>

              </template>
            </el-table-column>
            <el-table-column prop="visaLegend" label="国家-类型">
              <template slot-scope="scope">
                <p>{{ scope.row.countryName }}</p>
                <p>{{ scope.row.visaTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="visaTitle" label="产品名称" min-width="160">
              <template slot-scope="scope">
                <p>{{ scope.row.visaTitle }}</p>
                <div v-if="scope.row.marks">
                  <el-tooltip placement="top" :content="scope.row.marks">
                    <div class="marks-text" style="color: #e41313;">{{ scope.row.marks }} </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="申请-出签-拒签" width="160">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">
                    <div>{{ scope.row.num }}-{{ scope.row.succeedNum }}-{{ scope.row.failedNum }}</div><br />
                    <div class="marks-text">预出行时间：{{ formatTime2(scope.row.departureTime) }}</div>
                  </div>
                  <div>
                    <div>{{ scope.row.num }}-{{ scope.row.succeedNum }}-{{ scope.row.failedNum }}</div>
                    <div style="display: inline-flex;justify-content: center;align-items: center;">
                      <div class="overflow-ellipsis">
                        预出行： {{ scope.row.departureTime && formatTime2(scope.row.departureTime) }}
                      </div>
                      <el-link type="primary" @click.stop="openChangeTime(scope.row, '出行日期')"
                        icon="el-icon-edit-outline"></el-link>
                    </div>
                  </div>
                </el-tooltip>

                <el-tooltip placement="top">
                  <div slot="content">
                    <div class="marks-text">预出签时间：{{ formatTime2(scope.row.planVisaDate) }}</div>
                  </div>
                  <div style="display: inline-flex;justify-content: center;align-items: center;">
                    <div class="overflow-ellipsis">
                      预出签：{{ scope.row.planVisaDate && formatTime2(scope.row.planVisaDate) }}
                    </div>
                    <el-link type="warning" @click.stop="openChangeTime(scope.row, '预计出签日期')"
                      icon="el-icon-edit-outline"></el-link>
                  </div>
                </el-tooltip>

              </template>
            </el-table-column>
            <el-table-column prop="statusName" label="订单状态" width="100">
              <template slot-scope="scope" @click.stop>
                <el-tag :type="setStatus(scope.row.status)" size="small"> {{ scope.row.statusName }} </el-tag>
                <el-link type="primary" @click.stop="openChangeStatus(scope.row)" style="margin-top: 10px;">变更</el-link>
              </template>
            </el-table-column>

            <el-table-column prop="userName" label="来源" class="kaka" min-width="180">
              <!-- orderSource  0：商户 1：平台 2:用户 3:API接口 -->
              <template slot-scope="scope">
                <div>
                  <div>
                    {{ scope.row.appName }}
                    <span v-if="scope.row.appType.indexOf('微信') > -1" class="source-type"
                      style="padding: 2px 4px;background-color: #168743;"> 微 </span>
                    <span v-else-if="scope.row.appType.indexOf('支付宝') > -1" class="source-type"
                      style="padding: 2px 4px;background-color: #0085ff;"> 支</span>
                    <span v-else-if="scope.row.appType" class="source-type"
                      style="padding: 2px 4px;background-color: #ff6c37;"> {{ scope.row.appType }} </span>
                  </div>
                  <div>
                    {{ scope.row.merchatInfo && scope.row.merchatInfo.companyName || '--' }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="contacts" label="联系人信息" min-width="120px">
              <template slot-scope="scope">
                <span class="source-type" :style="{
                  background: setOrderSourceColor(scope.row.orderSource),
                }">{{ setOrderSourceText(scope.row.orderSource) }}</span>
                <span>{{ scope.row.contacts ? scope.row.contacts : "--" }}</span><br />
                <span>{{
                  scope.row.contactPhone ? scope.row.contactPhone : "--"
                }}</span>
                <div @click.stop="">
                  <el-dropdown size="mini" style="display: inline-flex"
                    @command="(command) => updateBindwechatnameFn(command, scope.row)">
                    <span class="source-type" :style="{ background: '#168743' }">
                      <i class="el-icon-service"></i>客
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in customerServiceList" :key="index" :command="item">
                        {{ (item.wechatName || '--') + `(${item.name})` }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-if="scope.row.wechatName" :title="scope.row.wechatName"
                  style="transform: scale(0.6);transform-origin: left;white-space: nowrap;">{{ scope.row.wechatName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="serviceMarks" label="操作备注" min-width="100">
              <template slot-scope="scope">
                <div>
                  <div v-if="scope.row.marks">
                    <el-tooltip placement="top" :content="scope.row.marks">
                      <div class="marks-text" style="color: #e41313;">{{ scope.row.marks }} </div>
                    </el-tooltip>
                  </div>
                  <div style="margin-top: 5px;">
                    <i slot="reference" class="iconfont icon-a-xiugai1"
                      @click.stop="showMarksDialog(scope.row, scope.$index)"></i>

                    <span class="marks-line">{{
                      scope.row.serviceMarks ? scope.row.serviceMarks : "--"
                    }}</span>
                    <span class="marks-icon">
                      <div class="marks-dialog" v-show="marksIndex == scope.$index" @click.stop v-clickOutside="() => {
                        marksIndex = -1;
                      }
                        ">
                        <p>操作备注</p>
                        <el-input v-model="curOrderItem.serviceMarks" type="textarea" :rows="4" resize="none" />
                        <div class="marks-btn">
                          <el-button class="default" @click="handleSaveMarks">保存</el-button>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" header-align="center" width="120">
              <template slot-scope="scope">
                <template v-if="relatedOrdersId && scope.row.id != relatedOrdersId">
                  <el-button size="mini" @click="comRelatedOrdersFn(scope.row)"
                    style="transform: scale(0.8);">确认关联</el-button>
                </template>
                <template v-else slot-scope="scope">
                  <div class="edit-wrap2">
                    <div class="edit-item" @click.stop>
                      <span class="lan" @click.stop="openElectron(scope.row)">查看</span>
                      <!-- scope.row.paymentStatus == 1&& -->
                      <span class="lan" v-if="price(scope.row) > 0"
                        @click="handleCommand('tuikuan', scope.row)">退款</span>
                      <!-- <span class="lan" v-if="price(scope.row)>0 && [4, 6, 7].indexOf(scope.row.status) !== -1 " @click="handleCommand('logistics', scope.row)"> {{ scope.row.expressResult? '查看物流' : '绑定物流'}}</span> -->

                      <!-- v-if="[-1, -2, 0, 1, 2].indexOf(scope.row.status) == -1" -->
                      <!-- <el-dropdown v-if="false" trigger="hover" @command="handleCommand($event, scope.row)">
                        <span class="lan" style="cursor: pointer; font-size: 12px">展开<i class="el-icon-arrow-down el-icon--right"></i></span>
                          <el-dropdown-item :command="item.value" v-for="(item, index) in setDropdown(scope.row.status).arr" :key="index" >{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown> -->
                    </div>
                    <div class="edit-item" @click.stop>
                      <el-dropdown style="transform: scale(0.6);" @command="handleCommand($event, scope.row)">
                        <el-button class="default">批量处理<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="a">批量下载</el-dropdown-item>
                          <el-dropdown-item command="b" v-if="scope.row.autocommit">批量提交</el-dropdown-item>
                          <el-dropdown-item command="e">发送邮件</el-dropdown-item>
                          <!-- <el-dropdown-item v-if="price(scope.row)>0 && scope.row.status >= 3 " command="logistics">{{ scope.row.expressNo? '查看物流' : '绑定物流'}}</el-dropdown-item> -->
                          <el-dropdown-item command="handlelogistics">查看物流</el-dropdown-item>
                          <!-- 等待面试 -->
                          <el-dropdown-item command="handleInterview">查看面试</el-dropdown-item>
                          <!-- 查看订单评价 -->
                          <!-- <el-dropdown-item  command="handleEvaluation">查看评价</el-dropdown-item> -->
                          <!-- <el-dropdown-item v-if="scope.row.status == 3 || scope.row.status == 31" command="logistics">查看物流</el-dropdown-item> -->
                          <!-- <el-dropdown-item :command="item.value" v-for="(item, index) in setDropdown(scope.row.status).arr" :key="index" >{{item.name}}</el-dropdown-item> -->
                          <el-dropdown-item command="qrcode" v-if="scope.row.orderSource == 1">生成二维码</el-dropdown-item>
                          <!-- 更改面试结果弹窗 -->
                          <el-dropdown-item command="handleChangeResult"
                            v-if="scope.row.status == 45">更改面试结果</el-dropdown-item>
                          <!-- <el-dropdown-item  command="handleChangeResult">更改面试结果</el-dropdown-item> -->

                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div class="edit-item" @click.stop><span class="lan"
                        @click.stop="handleCopyOrderUser(scope.row)">复用申请人下单</span></div>
                  </div>
                </template>
              </template>

            </el-table-column>
          </el-table>
        </div>

        <div class="table-pagination">
          <el-pagination @current-change="currentChange" :current-page="formDate.pageIndex" @size-change="sizeChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="formDate.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="formDate.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 退款 -->
    <el-dialog :visible.sync="outPricedio" width="419px" class="quan-dialog-out-class" :close-on-click-modal="true">
      <div class="dialog-member-title">
        <span class="dialog-member-name">退款操作</span>
        <div class="dialog-close" @click="outPricedio = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="quan-num-add" style="margin-top: 20px">
        <div class="quan-num-add-item">
          <span class="quan-num-add-title">退款金额</span>
          <div>
            <span>订单剩余{{ orderItem.reiduePrice }}元</span>
            <span class="quan-num-right" @click="outPrice.price = orderItem.reiduePrice">全部退款</span>
          </div>
        </div>

        <el-input type="Number" min="0.01" :max="orderItem.reiduePrice" class="quan-num-input" v-model="outPrice.price"
          @input="verification"></el-input>

        <div class="quan-num-add-item">
          <span class="quan-num-add-title">退款原因</span>
        </div>

        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="outPrice.text" class="quan-num-input"
          style="margin-bottom: 25px">
        </el-input>

        <div class="packge-btn-add">
          <el-button class="pageck-btn" @click="outPricedio = false">取消</el-button>
          <el-button class="pageck-btn default" type="primary" @click="outSubmit">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <addUserInfoTwo :config="newAddUserShow" @addUserFn="addUserFn" @close="newAddUserShow = false" :isAddOrder="true"
      :visaDocs="[]" v-if="newAddUserShow">
    </addUserInfoTwo>
    <!-- 批量操作 -->
    <batchApplication ref="batchApplicationRef" :visible="tjShow" :orderId="orderItem.id" :visaId="orderItem.visaId"
      :dowmShow="dowmShow" :downTitle="downList.title" @close="tjShow = false; dowmShow = false" @refresh="this.queryorderapplicantorgFn(
        this.curOrderItem.id,
        this.curOrderItem
      );" :orderDetail="{ order: orderItem }" @confirm="confirmSubmit"></batchApplication>

    <!-- 变更状态 -->
    <el-dialog :visible.sync="changeStatusShow" width="419px" class="quan-dialog-out-class"
      :close-on-click-modal="true">
      <div class="dialog-member-title">
        <span class="dialog-member-name">变更{{ changeStatusType }}</span>
        <div class="dialog-close" @click="changeStatusShow = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="quan-num-add">
        <div class="quan-num-add-item" style="margin: 30px 0" v-if="changeStatusType == '订单状态'">
          <el-form label-position="left">
            <el-form-item label="订单状态" style="margin-bottom: 0">
              <el-select v-model="changeStatusValue" filterable placeholder="请选择">
                <el-option v-for="(item, index) in orderStatusList" :key="index" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="订单流程" style="margin-bottom: 0">
              <el-select v-model="changeProcessValue" filterable placeholder="请选择">
                <el-option
                  v-for="(item,index) in orderFlowList"
                  :key="index"
                  :label="item.title"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
          <!-- 
          <el-radio-group v-model="changeStatusValue">
            <el-radio style="width: 90px;margin-top: 10px;" v-for="(item,index) in orderStatusList" :key="index" :label="item.value"> {{ item.label }}</el-radio>
          </el-radio-group> -->

        </div>
        <div style="margin: 30px 0" v-else-if="changeStatusType == '订单收银'">
          <el-select clearable v-model="changeStatusValue" size="small" style="margin: 10px 0; width: 100%;"
            placeholder="收银方式" filterable autocomplete="off">
            <el-option v-for="item in orderPayList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="changePriceValue" clearable type="number" size="small" placeholder="收银金额"></el-input>
        </div>
        <div class="quan-num-add-item" style="margin: 30px 0" v-else>
          <el-date-picker v-model="changeStatusValue" type="date" :placeholder="`选择${changeStatusType}`"
            value-format="yyyy-MM-dd">
          </el-date-picker>

        </div>
        <div class="packge-btn-add">
          <el-button class="pageck-btn" @click="changeStatusShow = false">取消</el-button>
          <el-button class="pageck-btn default" type="primary" @click="changeStatusSubmit">确认</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 查看面试弹窗 -->
    <interviewDialog :show="intervirewDialogShow" :intervirewDialogData="intervirewDialogData"
      @closeDialog="intervirewDialogShow = false" />
    <!-- 查看物流弹窗 -->
    <LogisticsDialog :show="logisticsDialogShow" :PreOrderItem="orderItem" :companySuoJson="companySuoJson"
      @closeDialog="logisticsDialogShow = false" />
    <!-- 修改面试状态弹窗 -->
    <InterviewResultDialog :show="interviewResultDialogShow" :orderItem="orderItem"
      @closeDialog="interviewResultDialogShow = false" />
    <!-- 查看物流 -->
    <el-dialog :visible.sync="logisticsShow" width="419px" class="quan-dialog-out-class" :close-on-click-modal="true">
      <div class="dialog-member-title">
        <span class="dialog-member-name">查看物流</span>
        <div class="dialog-close" @click="logisticsShow = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="quan-num-add">
        <el-row>
          <el-form ref="ruleForm" label-width="110px">
            <el-form-item label="用户名称：" prop="userName">
              {{ orderItem.userName }}
            </el-form-item>
            <el-form-item label="用户电话：" prop="userPhone">
              {{ orderItem.userPhone }}
            </el-form-item>
            <el-form-item label="用户地址：" prop="userAddress">
              {{ orderItem.userProvince }}-
              {{ orderItem.userCity }}-
              {{ orderItem.userDistrict }}-
              {{ orderItem.userAddress }}
            </el-form-item>
          </el-form>
          <el-form ref="ruleForm" :model="orderItem" :rules="logisticsRules" label-width="110px">
            <el-form-item label="物流公司：" prop="exCompany">
              <el-select v-model="orderItem.exCompany" filterable clearable @change="courierChange">
                <el-option :label="item.label" :value="item" v-for="item in companySuoJson"
                  :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流单号：" prop="expressNo">
              <el-input v-model="orderItem.expressNo" clearable></el-input>
            </el-form-item>
          </el-form>
          <el-collapse value="2" style="width: 100%; margin-top: 20px;height: 240px;overflow-y: auto;">
            <el-collapse-item title="物流信息" name="2">
              <template slot="title">
                <i class="header-icon el-icon-truck icon-title" style="font-size: 20px;"></i> 物流信息
                <!-- <i class="header-icon el-icon-refresh icon-title" style="margin-left: 3rem" @click.stop="getLogisticsFun"></i> -->
              </template>
              <el-steps :space="40" :active="1"
                :finish-status="orderItem.expressResult && orderItem.expressResult.ischeck" direction="vertical">
                <el-step v-if="!(orderItem.expressResult && orderItem.expressResult.com)"
                  description="未绑定物流信息哟"></el-step>
                <el-step
                  v-else-if="!(orderItem.expressResult && (orderItem.expressResult.data || orderItem.expressResult.data.length == 0))"
                  description="亲！ 暂时还没有物流信息哟"></el-step>
                <div v-else>
                  <el-step v-for="(item, index) in orderItem.expressResult.data" :key="index"
                    :description="item.Time + '------' + item.Context"></el-step>
                </div>
              </el-steps>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </div>
      <div class="packge-btn-add">
        <el-button class="pageck-btn" @click="logisticsShow = false">关闭</el-button>
        <el-button class="pageck-btn default" type="primary" @click="submitLogistics()"
          v-if="!(orderItem && orderItem.expressNo)">确认</el-button>
      </div>
    </el-dialog>

    <!-- 匹配订单护照页-->
    <selectionUpload :visible="selectionUploadShow" :selectionRow="selectionRow" @close="closeSelectionUpload">
    </selectionUpload>

    <!-- 匹配批量导入Excel -->
    <selectionUploadExcel :visible="selectionUploadExcelShow" :selectionRow="selectionRow"
      @close="closeSelectionUploadExcel"></selectionUploadExcel>
    <!-- 关联二维码 -->
    <orderQRCodeDialog :visible="isQrcodeImg" :orderDetail="{ order: orderItem }" @close="isQrcodeImg = false">
    </orderQRCodeDialog>
    <!-- 批量下载名单 -->
    <orderDownloadDialog :visible="isDownloadShow" :PlanVisaDateTime="PlanVisaDateTime" :dateInfo="dateInfo"
      :formDate="formDate" @close="isDownloadShow = false"></orderDownloadDialog>
    <!-- 复用人员下单 -->
    <applicantReuse :visible="reuseDialog" @close="handleApplicantClose" :reuseData="reuseData" />
  </div>
</template>

<script>
import { appinfoquery } from "@/api/settings.js"
import {
  orderstatusselect,
  orderapplcantstatusselect,
  queryorderapplicants,
  orderrefund,
  ordermodifystatus,
  upadateorderdeparturetime,
  upadateorderplanvisadate,
  upadateorderpaytypeandorderprice,

  uploadvisapage,
  connectorder,
  getorderflow,
  bindwechatname,
  paytypeselect,
  batchsubmitapplicant,
} from "@/api/order.js";

import { countrylist, visatypelist } from "@/api/personal.js";
import { querycustomerservice } from "@/api/settings.js";

import {
  queryorderorg,
  merchatlist,
  orderremarks,
} from "@/api/orderCenter.js";

import batchApplication from "../../components/batchApplication.vue";
import addUserInfoTwo from "@/components/addUserInfoTwo.vue";
import selectionUpload from "./components/selectionUpload";
import selectionUploadExcel from "./components/selectionUploadExcel.vue";
import orderDownloadDialog from "./components/orderDownloadDialog.vue";
import orderQRCodeDialog from "./components/orderQRCodeDialog.vue";
import applicantReuse from "./components/applicantReuse.vue";
import LogisticsDialog from "./components/LogisticsDialog.vue";
import interviewDialog from "./components/interviewDialog.vue";
import time1 from "@/assets/images/order/time1.png";
import time2 from "@/assets/images/order/time2.png";
import alyoss from "@/utils/alyoss";
import { EventBus } from '@/utils/eventBus.js';
import { setSessionStorage, getSessionStorage } from "@/utils/auth";
import InterviewResultDialog from "./components/InterviewResultDialog.vue";

export default {
  name: 'orderCenter',
  data() {
    return {
      // 面试结果弹窗
      interviewResultDialogShow: false,
      logisticsDialogShow: false,
      intervirewDialogShow: false,
      isShowSearch: false,
      menuActive: 0,
      tui: {
        total: "",
      },
      menuList: [
        {
          name: "全部",
          label: -99,
          value: 0,
        },
        {
          name: "待上传",
          label: 0,
          value: 0,
        },
        {
          name: "待寄出",
          label: 3,
          value: 0,
        },
        {
          name: "邮寄中",
          label: 31,
          value: 0,
        },
        {
          name: "待审核",
          label: 4,
          value: 0,
        },
        {
          name: "待面试",
          label: 45,
          value: 0,
        },
        {
          name: "待出签",
          label: 5,
          value: 0,
        },
        {
          name: "待寄回",
          label: 61,
          value: 0,
        },
        {
          name: "回寄中",
          label: 62,
          value: 0,
        },
        {
          name: "已完成",
          label: 7,
          value: 0,
        },
      ],
      colors: [
        { color: "#E41313", percentage: 50 },
        { color: "#EEBB17", percentage: 99 },
        { color: "#1C9C1C", percentage: 100 },
      ],
      dropdownList: [
        {
          name: "退款",
          value: "a",
        },
        {
          name: "填写物流",
          value: "b",
        },
        {
          name: "查看物流",
          value: "c",
        },
        {
          name: "恢复",
          value: "d",
        },
      ],
      expands: [],
      dateInfo: [],
      PlanVisaDateTime: [],
      loading: false,
      outPricedio: false,
      newAddUserShow: false,
      formDate: {
        CountryId: "",
        VisaTypeId: "",
        OrderStatus: "",
        OrderSource: "",
        ApplcantStatus: "",
        Key: "",
        StartTime: "",
        EndTime: "",
        MerchatId: "",
        AppIdLong: "",
        pageIndex: 1,
        pageSize: 10,
        pageTotal: 0,
        menuActive: 0,
        PayType: '',
        PlanVisaStartTime: '',
        PlanVisaEndTime: '',
        Status: '',
      },
      outPrice: {
        price: "",
        text: "",
      },
      orderStatusList: [],
      orderSourceList: [
        { label: "商户", value: "0" },
        { label: "平台", value: "1" },
        { label: "用户", value: "2" },
        { label: "平台Api", value: "3" }
      ],
      selectStatus: [],
      countryData: [],
      visaType: [],
      orderOrgList: [],
      orderUserList: [],
      continent: [],
      orderItem: {},
      loadingOrder: false,
      getRowKeys(row) {
        return row.id || "";
      },
      dateWrap: {
        totalCount: "",
        waitingCount: "",
        FinishiCount: "",
        PendingCount: "",
      },
      time2: time2,
      time1: time1,
      marksIndex: -1,
      orderApplicantId: "",
      curOrderItem: {},
      timer: null,
      appinfoList: [],


      dowmShow: false,
      tjShow: false,
      changeStatusShow: false,
      changeStatusType: '订单状态',
      changeStatusValue: '',
      changeProcessValue: '', //订单流程
      changePriceValue: 0,
      downList: {
        pageIndex: 1,
        pageSize: 10,
        title: ''
      },
      currentRequestId: 0, // 当前请求的唯一标记
      relatedOrdersId: 0, // 关联订单的orderid
      customerServiceList: [],

      logisticsShow: false,
      logisticsRules: {
        exCompany: [
          { required: true, message: '请选择快递公司', trigger: ['change', 'blur'] }
        ],
        expressNo: [
          { required: true, message: '请填写订单号', trigger: ['change', 'blur'] }
        ],
      },
      companySuoJson: [
        { label: '申通快递', value: 'shentong' },
        { label: '顺丰快递', value: 'shunfeng' },
        { label: '韵达快递', value: 'yunda' },
        { label: '天天快递', value: 'tiantian' },
        { label: '百世快运', value: 'baishiwuliu' },
        { label: '圆通快递', value: 'yuntong' },
        { label: '中通快递', value: 'zhongtong' },
        { label: 'EMS', value: 'ems' },
        { label: '优速快递', value: 'youshuwuliu' },
        { label: '京东快递', value: 'jd' },
        { label: '德邦物流', value: 'dabangwuliu' },
        { label: '宅急送', value: 'zhaijisong' },
        { label: '邮政快递包裹', value: 'youzhengguonei' },
        { label: '汇通快递', value: 'huitongkuaidi' }
      ],
      orderPayList: [],
      saleAmount: 0,
      visingCount: 0,
      failedCount: 0,
      visaTodayCount: 0,
      suceedCount: 0,
      entryCardAmount: 0,

      selectionShow: false,
      selectionUploadShow: false,
      selectionUploadExcelShow: false,
      isDownloadShow: false,
      selectionRow: [],

      isQrcodeImg: false,
      submitLoading: false,
      reuseDialog: false,
      reuseData: {},
      intervirewDialogData: {},
      // 评价弹窗
      isEvaluateDialogShow: false,
      evaluateDialogData: {},
      orderFlowList: [],
    };
  },
  components: {
    addUserInfoTwo, batchApplication, selectionUpload, orderQRCodeDialog, selectionUploadExcel, orderDownloadDialog, applicantReuse, LogisticsDialog, interviewDialog, InterviewResultDialog
  },
  created() {
    EventBus.$on('checkFinance', () => {
      this.$router.push({ name: 'settings', params: { menuActive: '5' } }).catch(() => { });
    });
  },
  activated() { },
  mounted() {
    this.getParams();
    this.getOrderstatusselect();
    this.getOrderapplcantstatusselect();
    this.getCountrylist();
    this.getVisatypelist();
    this.getQueryorderorg();
    this.getMerchatlist();
    this.getAppinfoquery();
    this.getCustomerserviceFn();
    this.formDate.OrderSource = getSessionStorage('OrderSource');
  },
  computed: {
    formatTime() {
      return (value) => {
        return this.$moment(value).format("YY-MM-DD HH:mm");
      }
    },
    formatTime2() {
      return (value) => {
        return this.$moment(value).format("YY-MM-DD");
      }
    },
    price() {
      return (item) => {
        let priceNum = item.paidAmount - item.refundAmount;
        // 保留两位小数并且小数点后无零则不显示小数点
        return priceNum.toFixed(2).replace(/\.?0+$/, '');
      }
    },
    // setStatus() {
    //   return function (status) {
    //     if (status == -4 || status == -2 || status == -3 || status == 2) {
    //       return "danger";
    //     } else if ([0, 1, 3, 4, 5, 31].indexOf(status) > -1) {
    //       return "warning";
    //     } else if ([6, 7, 8].indexOf(status) > -1) {
    //       return "success";
    //     } else {
    //       return "info";
    //     }
    //   };
    // },
    setStatus() {
      return function (status) {
        if (status == -4 || status == -2 || status == -3 || status == 2 || status == -1) {
          return "danger";
        } else if ([6, 7, 8].indexOf(status) > -1) {
          return "success";
        } else {
          return "warning";
        }
      };
    },
    setDropdown() {
      return function (status) {
        let arr = [];
        // if ([3, 4, 7].indexOf(status) !== -1) {
        //   arr.push({
        //     name: "退款",
        //     value: "tuikuan",
        //   });
        // }

        if ([4].indexOf(status) !== -1) {
          arr.push({
            name: "填写物流",
            value: "editLogistics",
          });
        }

        if ([6, 7].indexOf(status) !== -1) {
          arr.push({
            name: "查看物流",
            value: "selLogistics",
          });
        }

        // if ([6, 7].indexOf(status) !== -1) {
        //   arr.push({
        //     name: "恢复",
        //     value: "d",
        //   });
        // }
        return { arr };
      };
    },
    setOrderSourceText() {
      return function (num) {
        let str = "";
        switch (num) {
          case 0:
            str = "商";
            break;
          case 1:
            str = "平";
            break;
          case 2:
            str = "用";
            break;
          default:
            str = "接";
        }
        return str;
      };
    },
    setOrderSourceColor() {
      return function (num) {
        let str = "";
        switch (num) {
          case 0:
            str = "#4791EA";
            break;
          case 1:
            str = "#49BD49";
            break;
          case 2:
            str = "#F79534";
            break;
          default:
            str = "#EA4747";
        }
        return str;
      };
    },
    setTopClass() {
      return function (identityType) {
        if ([0, 2, 14, 6, 11, 18].indexOf(identityType) >= 0) {
          return "color:#eebb17"; //黄色
        } else if ([8, 10, 12, 16].indexOf(identityType) >= 0) {
          return "color:#1c9c1c"; //绿色
        } else {
          return "color:#e41313"; //红色
        }
      };
    },
    setPaidAmountColor() {
      return function (row) {
        let str = "";
        if (row.tradeTypeName.indexOf('支付宝') > -1) {
          str = "#409EFF"
        } else if (row.tradeTypeName.indexOf('微信') > -1) {
          str = "#168743"
        } else if (row.tradeTypeName.indexOf('淘宝') > -1) {
          str = "#E6A23C"
        } else {
          str = "#F56C6C"
        }
        return str;
      };
    },
  },

  methods: {
    handleChangeOrderStatus() {
      let index = this.menuList.findIndex(item => item.label == this.formDate.OrderStatus)
      this.formDate.menuActive = index;
      this.getQueryorderorg(1)
    },
    // 科学技术法转数值 千位显示K 万位显示W
    setNumber(num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + "W";
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + "K";
      } else {
        return num;
      }
    },
    // 获取订单状态
    handleGetorderflow(orderId) {
      getorderflow({ orderId }).then(res => {
        if (res.code == 1) {
          this.orderFlowList = res.data
        }
      })
    },
    handleApplicantClose(flage) {
      this.reuseDialog = false;
      if (flage) this.getQueryorderorg()
    },
    // 点击复用申请人下单
    handleCopyOrderUser(row) {
      this.reuseData = row
      this.reuseDialog = true;

    },
    // 点击人数筛选
    handleStatusChange(ApplcantStatus) {
      let date = this.$moment().format('YYYY-MM-DD')
      this.dateInfo = []
      this.formDate = {
        CountryId: "",
        VisaTypeId: "",
        OrderStatus: "",
        OrderSource: getSessionStorage('OrderSource'),
        ApplcantStatus,
        Key: "",
        StartTime: "",
        EndTime: "",
        MerchatId: "",
        AppIdLong: "",
        pageIndex: 1,
        pageSize: 10,
        pageTotal: 0,
        menuActive: this.formDate.menuActive,
        PayType: '',
        PlanVisaStartTime: '',
        PlanVisaEndTime: '',
      };
      if (ApplcantStatus == -5) {
        // 使用moment获取今日年月日
        let preDate =  this.$moment(new Date(2025, 0, 1)).format('YYYY-MM-DD')
        this.formDate.PlanVisaStartTime = preDate
        this.formDate.PlanVisaEndTime = date
        this.PlanVisaDateTime = [preDate, date]
        this.formDate.ApplcantStatus = ''
        this.formDate.OrderStatus = 5
        let index = this.menuList.findIndex(item => item.label == this.formDate.OrderStatus)
        this.formDate.menuActive = index;
        this.$forceUpdate()

      }
      this.relatedOrdersId = 0;
      this.getQueryorderorg();
    },
    //验证退款金额
    verification(val) {
      if (val > this.orderItem.reiduePrice) {
        this.outPrice.price = this.orderItem.reiduePrice;
        return this.$message({
          message: "退款金额不能大于剩余金额",
          type: "warning",
        });
      }
      if (val <= 0) {
        this.outPrice.price = 0.01;
        return this.$message({
          message: "退款金额必须大于0",
          type: "warning",
        });
      }
    },
    getParams() {
      this.formDate.CountryId = this.$route.params.id;
      if (this.formDate.CountryId) {
        this.getQueryorderorg();
      }
    },
    showMarksDialog(val, index) {
      this.marksIndex = index;
      this.curOrderItem = JSON.parse(JSON.stringify(val));
    },
    cellStyleFn({ row, column, rowIndex, columnIndex }) {
      if (column.label == "创建人") {
        return { "text-align": "left" };
      } else {
        return { "text-align": "center" };
      }
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.label == "操作备注") {
        return "cellMarks";
      }
    },
    handleSaveMarks() {
      orderremarks({
        orderId: this.curOrderItem.id,
        remarks: this.curOrderItem.serviceMarks,
      }).then((res) => {
        this.$message.success("修改成功！");
        this.getQueryorderorg();
        this.marksIndex = -1;
      });
    },
    async uploadVisapage(file) {
      let alyossData = await alyoss(file.file);
      uploadvisapage({
        orderApplicantId: this.orderApplicantId,
        visaPage: alyossData,
      }).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "上传成功！",
            type: "success",
          });
          this.queryorderapplicantorgFn(
            this.curOrderItem.id,
            this.curOrderItem
          );
        }
      });
    },
    openFile(url) {
      window.open(url);
    },
    getQueryorderorg(pageIndex) {
      console.log(this.formDate)
      let vm = this;
      vm.formDate.pageIndex = pageIndex || vm.formDate.pageIndex;
      this.loading = true;
      vm.orderOrgList = [];
      // 缓存订单来源
      setSessionStorage('OrderSource', vm.formDate.OrderSource)

      const requestId = ++this.currentRequestId;
      queryorderorg({
        "Page.Size": vm.formDate.pageSize,
        "Page.Index": vm.formDate.pageIndex,
        CountryId: vm.formDate.CountryId,
        VisaTypeId: vm.formDate.VisaTypeId,
        OrderStatus: vm.formDate.OrderStatus == -99 ? '' : vm.formDate.OrderStatus,
        OrderSource: vm.formDate.OrderSource,
        ApplcantStatus: vm.formDate.ApplcantStatus,
        Key: vm.formDate.Key,
        StartTime: vm.formDate.StartTime,
        EndTime: vm.formDate.EndTime,
        MerchatId: vm.formDate.MerchatId,
        AppIdLong: vm.formDate.AppIdLong,
        PayType: vm.formDate.PayType,
        PlanVisaStartTime: vm.formDate.PlanVisaStartTime,
        PlanVisaEndTime: vm.formDate.PlanVisaEndTime,
      }).then((res) => {
        if (res.data && (requestId === this.currentRequestId)) {
          vm.orderOrgList = res.data.row;

          (this.menuList = [
            {
              name: "全部",
              label: -99,
              value: res.data.total,
            },
            {
              name: "待上传",
              label: 0,
              value: res.data.uploadCount ? this.setNumber(res.data.uploadCount) : 0,
            },
            {
              name: "待寄出",
              label: 3,
              value: res.data.sendCount ? this.setNumber(res.data.sendCount) : 0,
            },
            {
              name: "邮寄中",
              label: 31,
              value: res.data.sendingCount ? this.setNumber(res.data.sendingCount) : 0,
            },
            {
              name: "待审核",
              label: 4,
              value: res.data.pendingCount ? this.setNumber(res.data.pendingCount) : 0,
            },
            {
              name: "待面试",
              label: 45,
              value: res.data.interviewCount ? this.setNumber(res.data.interviewCount) : 0,
            },
            {
              name: "待出签",
              label: 5,
              value: res.data.waitingCount ? this.setNumber(res.data.waitingCount) : 0,
            },
            {
              name: "待寄回",
              label: 61,
              value: res.data.returnCount ? this.setNumber(res.data.returnCount) : 0,
            },
            {
              name: "回寄中",
              label: 62,
              value: res.data.returningCount ? this.setNumber(res.data.returningCount) : 0,
            },
            {
              name: "已完成",
              label: 7,
              value: res.data.finishiCount ? this.setNumber(res.data.finishiCount) : 0,
            }
          ]),
            vm.orderOrgList.forEach((item) => {
              item.createdTime = item.createdTime // .split(" ")[0];
              item.pageIndex = 1;
              item.pageTotal = 0;
              item.pageSize = 5;
            });
          vm.formDate.pageTotal = res.data.totalCount;
        }
        this.saleAmount = res.data.saleAmount || 0
        this.visingCount = res.data.visingCount || 0
        this.failedCount = res.data.failedCount || 0
        this.suceedCount = res.data.suceedCount || 0
        this.visaTodayCount = res.data.visaTodayCount || 0
        this.entryCardAmount = res.data.entryCardAmount || 0
        vm.loading = false;
      });
    },

    async getOrderstatusselect() {
      let vm = this;

      let res = await orderstatusselect({});
      vm.orderStatusList = res.data;
      console.log(res.data, "订单状态");
    },
    async getOrderapplcantstatusselect() {
      let res = await orderapplcantstatusselect({});
      this.selectStatus = res.data;
      console.log(res.data);
    },

    getCountrylist() {
      countrylist({}).then((res) => {
        this.countryData = res.data;
      });
    },
    getVisatypelist() {
      visatypelist({}).then((res) => {
        this.visaType = res.data;
      });
    },
    // 商户
    getMerchatlist() {
      merchatlist({}).then((res) => {
        this.continent = res.data;
      });
      paytypeselect().then((res) => {
        this.orderPayList = res.data.map(item => {
          item.value += ''
          let text = ''
          if (item.label.length == 4) {
            text = item.label.charAt(0)
          } else if (item.label.indexOf('小红书') > -1) {
            text = '红'
          } else if (item.label.indexOf('支付宝') > -1) {
            text = '支'
          } else {
            text = item.label.charAt(1)
          }
          return { ...item, text }
        })
      });
    },
    openElectron(item, userId = "", page = {}) {
      console.log('item, userId', item, userId, page);

      // 资料上传页面默认选中点击查看的申请人
      sessionStorage.setItem("km_userId", userId);
      sessionStorage.setItem("km_userInfoPage", JSON.stringify(page));
      console.log(sessionStorage.getItem("km_userInfoPage"))
      let vm = this;
      //马来西亚插件
      if (item.systemVisaId === 1) {
        vm.$router.push({
          name: "malaysia",
          query: {
            id: item.id,
            userId,
          },
        });
        return;
      }
      if (item && item.autocommit) {
        vm.$router.push({
          name: "orderCenterElectron",
          params: {
            id: `${item.applicantName ? item.applicantName : "name"}-${item.identityTypeName ? item.identityTypeName : "type"}-${item.id}-${item.userId}-${item.systemVisaId}`,
          },
        });
      } else {
        vm.$router.push({
          name: "informations",
          params: { informations: userId, id: `${item.id}_${userId}` },
        });
      }
    },
    setActive(index, status) {
      this.formDate.menuActive = index;
      if (status == -99) {
        this.formDate.OrderStatus = ''
      } else {
        this.formDate.OrderStatus = status
      }
      this.getQueryorderorg(1);
    },
    addUserFn(data) {
      this.$message({
        message: "出行人信息未完善",
        type: "success",
      });
      this.newAddUserShow = false;
      this.$set(data.order, "systemVisaId", data.visaDetail.visa.systemVisaId);
      debugger;
      this.openElectron(data.order);
      this.getQueryorderorg();
    },
    queryorderapplicantorgFn(id, row) {
      this.loadingOrder = true;
      queryorderapplicants({
        OrderId: id,
        "Page.Size": row.pageSize,
        "Page.Index": row.pageIndex,
      }).then((res) => {
        this.loadingOrder = false;

        this.orderUserList = res.data.rows;
        this.orderOrgList.forEach((item) => {
          if (item.id == id) {
            item.pageTotal = res.data.total;
          }
        });
        this.$refs.refTable.doLayout();
      });
    },
    currentChange(e) {
      this.formDate.pageIndex = e;
      this.$refs.refTable.bodyWrapper.scrollTop = 0;
      this.getQueryorderorg();
    },
    sizeChange(e) {
      this.formDate.pageSize = e;
      this.$refs.refTable.bodyWrapper.scrollTop = 0;
      this.getQueryorderorg();
    },
    search() { },
    outSubmit() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        orderrefund({
          amount: this.outPrice.price,
          refundRemarks: this.outPrice.text,
          orderId: this.orderItem.id,
        })
          .then((res) => {
            clearTimeout(this.timer);
            if (res.code == 0) {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            } else {
              this.$message({
                message: "退款成功！",
                type: "success",
              });
              this.outPrice = {
                price: "",
                text: "",
              };
              this.outPricedio = false;
              this.getQueryorderorg();
            }
          })
          .catch(() => {
            clearTimeout(this.timer);
          });
      }, 200);
    },
    reset(index) {
      this.dateInfo = []
      this.formDate = {
        CountryId: "",
        VisaTypeId: "",
        OrderStatus: "",
        OrderSource: getSessionStorage('OrderSource'),
        ApplcantStatus: "",
        Key: "",
        StartTime: "",
        EndTime: "",
        MerchatId: "",
        AppIdLong: "",
        pageIndex: 1,
        pageSize: 10,
        pageTotal: 0,
        menuActive: this.formDate.menuActive,
        PayType: '',
        PlanVisaStartTime: '',
        PlanVisaEndTime: '',
      };
      this.relatedOrdersId = 0;
      this.PlanVisaDateTime = []
      this.formDate.menuActive = 0;
      this.getQueryorderorg();
    },
    openAdd() {
      this.newAddUserShow = true;
    },
    openSelection() {
      if (this.$refs.refTable.selection.length) {
        console.log('file', this.$refs.refTable.selection);
        this.selectionUploadShow = true;
        this.selectionRow = [...this.$refs.refTable.selection]
      } else {
        if (this.selectionShow) {
          this.$message("勾选订单后才能上传护照")
        }
        this.selectionShow = !this.selectionShow;
        this.selectionUploadShow = false;
      }
    },

    closeSelectionUpload() {

      this.selectionUploadShow = false;
      this.selectionShow = false;
      this.$refs.refTable.clearSelection();
      this.selectionRow = [];
    },
    closeSelectionUploadExcel() {
      this.selectionUploadExcelShow = false;
      this.selectionShow = false;
      this.$refs.refTable.clearSelection();
      this.selectionRow = [];
    },

    // 点击行展开事件
    clickTable(row, index, e) {
      this.curOrderItem = JSON.parse(JSON.stringify(row));
      this.queryorderapplicantorgFn(row.id, row);
      this.$refs.refTable.toggleRowExpansion(row);
    },
    currentPropsChange(e, row) {
      row.pageIndex = e;
      this.queryorderapplicantorgFn(row.id, row);
    },
    // 折叠面板每次只能展开一行
    expandSelect(row, expandedRows) {
      this.curOrderItem = JSON.parse(JSON.stringify(row));
      var that = this;
      if (expandedRows.length) {
        that.expands = [];
        if (row) {
          that.expands.push(row.id); // 每次push进去的是每行的ID
          that.queryorderapplicantorgFn(row.id, row);
        }
      } else {
        that.expands = []; // 默认不展开
      }
    },
    setDate(e) {
      if (!e) {
        this.formDate.StartTime = "";
        this.formDate.EndTime = "";
      } else {
        this.formDate.StartTime = e[0];
        this.formDate.EndTime = e[1];
      }

      this.getQueryorderorg();
    },
    setPlanVisaDate(e) {
      if (!e) {
        this.formDate.PlanVisaStartTime = "";
        this.formDate.PlanVisaEndTime = "";
      } else {
        this.formDate.PlanVisaStartTime = e[0];
        this.formDate.PlanVisaEndTime = e[1];
      }

      this.getQueryorderorg();
    },
    // 应用列表
    getAppinfoquery() {
      appinfoquery({ "Page.Index": 1, "Page.Size": 1000 }).then(res => {
        this.appinfoList = res.data.rows
      })
    },

    handleCommand(e, item) {
      if (e == "tuikuan") {
        this.orderItem = item;
        item.reiduePrice = item.paidAmount - item.refundAmount;
        this.outPricedio = true;
      } else if (e == "logistics") {
        this.logisticsShow = true;
        if (item.expressNo) {
          let itemInfo = JSON.parse(JSON.stringify(item))
          try {
            itemInfo.expressResult = JSON.parse(item.expressResult)
          } catch (error) { }
          this.orderItem = {
            customerServiceId: item.customerServiceId,
            userProvince: item.userProvince,
            userCity: item.userCity,
            userDistrict: item.userDistrict,
            userAddress: item.userAddress,
            userName: item.userName,
            userPhone: item.userPhone,
            ...itemInfo
          }
        } else {
          this.orderItem = {
            expressNo: '',
            exCompany: '',
            exCompanyCode: '',
            orderId: item.id,

            customerServiceId: item.customerServiceId,
            userProvince: item.userProvince,
            userCity: item.userCity,
            userDistrict: item.userDistrict,
            userAddress: item.userAddress,
            userName: item.userName,
            userPhone: item.userPhone,
          }
        }

      } else if (e == "qrcode") {
        this.orderItem = item;
        console.log('ddd', this.orderItem);

        this.isQrcodeImg = true;
      } else if (e == 'handleInterview') {
        this.intervirewDialogShow = true;
        this.intervirewDialogData = item;

      } else if (e == 'handleChangeResult') {
        // 修改面试结果
        this.orderItem = item
        this.interviewResultDialogShow = true;

      } else if (e == 'handleEvaluation') {
        // 查看评价
        this.isEvaluateDialogShow = true;
        this.evaluateDialogData = item;
      } else if (e == 'handlelogistics') {
        this.logisticsDialogShow = true;

        if (item.expressNo) {
          let itemInfo = JSON.parse(JSON.stringify(item))
          try {
            itemInfo.expressResult = JSON.parse(item.expressResult)
          } catch (error) { }
          this.orderItem = {
            customerServiceId: item.customerServiceId,
            userProvince: item.userProvince,
            userCity: item.userCity,
            userDistrict: item.userDistrict,
            userAddress: item.userAddress,
            userName: item.userName,
            userPhone: item.userPhone,
            ...itemInfo,
            ...item
          }
        } else {
          this.orderItem = {
            expressNo: '',
            exCompany: '',
            exCompanyCode: '',
            orderId: item.id,

            customerServiceId: item.customerServiceId,
            userProvince: item.userProvince,
            userCity: item.userCity,
            userDistrict: item.userDistrict,
            userAddress: item.userAddress,
            userName: item.userName,
            userPhone: item.userPhone,
            ...item
          }
        }
      } else {

        this.dowmShow = false;
        this.tjShow = false;
        this.orderItem = item;
        this.downList.orderId = item.id

        if (e == "a") {
          // 批量下载
          this.dowmShow = true;

          this.$refs.batchApplicationRef.getQueryorderapplicants(this.downList);
        } else if (e == "b") {
          this.downList.title = "批量提交"
          this.tjShow = true;
          setTimeout(() => {
            this.$refs.batchApplicationRef.getQueryorderapplicants({
              orderId: item.id,
              pageIndex: 1,
              pageSize: 1000,
            });
          }, 500);
        } else if (e == "e") {
          this.downList.title = "发送邮件"
          this.tjShow = true;
          setTimeout(() => {
            this.$refs.batchApplicationRef.getQueryorderapplicants({
              orderId: item.id,
              pageIndex: 1,
              pageSize: 1000,
            });
          }, 500);
        }
      }
    },
    // 表单外批量处理
    handleMultiple(e) {
      console.log(e)
      if (e == 'a') {
        // 导入护照
        this.openSelection()
      } else if (e == 'b') {
        // 批量导入excel
        this.selectionUploadExcelShow = true;
      } else if (e == 'c') {
        // 批量导出申请人
        this.isDownloadShow = true;
      }
    },

    changeStatusSubmit() {

      if (!String(this.changeStatusValue)) {
        return this.$message.error('请选择要变更的' + this.changeStatusType)
      }
      if (this.changeStatusType == '订单状态') {
        this.$confirm(`该操作为变更${this.changeStatusType}，是否确认继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.submitChangeStatus()
        })
      } else if (this.changeStatusType == '订单收银') {
        this.submitChangePrice()
      } else {
        this.submitChangeTime()
      }


    },
    openChangeStatus(item) {
      console.log(item, 'item数据')
      this.changeStatusType = '订单状态'
      this.changeProcessValue = item.processeCode
      this.handleGetorderflow(item.id)
      this.changeStatusShow = true
      this.changeStatusValue = item.status
      this.orderItem = item
    },
    openChangePrice(item) {
      this.changeStatusType = '订单收银'
      this.changeStatusShow = true
      this.changeStatusValue = String(item.tradeType)
      this.changePriceValue = ''
      this.orderItem = item
    },
    openChangeTime(item, title) {
      this.changeStatusType = title
      this.changeStatusShow = true
      if (title == '出行日期') {
        this.changeStatusValue = item.departureTime
      } else if (title == '预计出签日期') { //预计出签日期
        this.changeStatusValue = item.planVisaDate
      }

      this.orderItem = item
    },
    submitChangeStatus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        ordermodifystatus({
          status: this.changeStatusValue,
          orderId: this.orderItem.id,
          processeCode: this.orderItem.processCode,
        })
          .then((res) => {
            clearTimeout(this.timer);
            if (res.code == 0) {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            } else {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.changeStatusShow = false;
              this.getQueryorderorg();
            }
          })
          .catch(() => {
            clearTimeout(this.timer);
          });
      }, 200);
    },
    submitChangePrice() {
      if (!String(this.changeStatusValue)) {
        return this.$message.error('请选择收银方式')
      }

      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        upadateorderpaytypeandorderprice({
          amount: Number(this.changePriceValue),
          payType: this.changeStatusValue,
          orderId: this.orderItem.id,
        })
          .then((res) => {
            clearTimeout(this.timer);
            if (res.code == 0) {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            } else {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.changeStatusShow = false;
              this.getQueryorderorg();
            }
          })
          .catch(() => {
            clearTimeout(this.timer);
          });
      }, 200);
    },
    submitChangeTime() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        let apiName = null
        if (this.changeStatusType == '出行日期') {
          apiName = upadateorderdeparturetime({
            departureTime: this.changeStatusValue,
            orderId: this.orderItem.id,
          })
        } else if (this.changeStatusType == '预计出签日期') {
          apiName = upadateorderplanvisadate({
            planVisaDate: this.changeStatusValue,
            orderId: this.orderItem.id,
          })
        }
        apiName.then((res) => {
          clearTimeout(this.timer);
          if (res.code == 0) {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.changeStatusShow = false;
            this.getQueryorderorg();
          }
        })
          .catch(() => {
            clearTimeout(this.timer);
          });
      }, 200);

    },

    relatedOrdersFn(row) {
      console.log(row)
      queryorderapplicants({
        OrderId: row.id,
        "Page.Size": row.pageSize,
        "Page.Index": row.pageIndex,
      }).then((res) => {
        if (res.data.rows && res.data.rows.length) {
          this.relatedOrdersId = row.id;
          this.formDate.menuActive = 0;
          // 重置
          this.dateInfo = []
          this.formDate = {
            CountryId: "",
            VisaTypeId: "",
            OrderStatus: "",
            OrderSource: getSessionStorage('OrderSource'),
            ApplcantStatus: "",
            Key: res.data.rows[0].passportNumber,
            StartTime: "",
            EndTime: "",
            MerchatId: "",
            AppIdLong: "",
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            menuActive: this.formDate.menuActive,
            PayType: '',
            PlanVisaStartTime: '',
            PlanVisaEndTime: '',
          };
          this.getQueryorderorg();
        }


      });
      // this.getQueryorderorg(1);
    },
    comRelatedOrdersFn(row) {

      this.$confirm(`是否确认关联订单？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        connectorder({ connectOrderId: row.id, orderId: this.relatedOrdersId }).then(res => {

          this.$message({
            message: '关联订单成功！',
            type: 'success'
          });
          this.relatedOrdersId = 0
        })
      }).catch(res => {

      })
    },
    getCustomerserviceFn() {
      querycustomerservice({ 'pageIndex': 1, 'pageSize': 100 }).then(res => {
        this.customerServiceList = res.data.rows
      })
    },
    updateBindwechatnameFn(command, row) {
      this.$confirm(`此操作将${row.orderNo}订单绑定（${command.wechatName}）客服`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        bindwechatname({
          "customerServiceId": command.id,
          "connectOrderId": row.id
        }).then(() => {
          this.$message({
            message: '关联订单成功！',
            type: 'success'
          });
          row.wechatName = command.wechatName;
        })
      }).catch(() => { })

    },

    courierChange(item) {
      this.orderItem.exCompanyCode = item.value
      this.orderItem.exCompany = item.label
    },
    submitLogistics() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.saveLogistics()
        } else {
          return false;
        }
      });

    },
    saveLogistics() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        ordermodifystatus({
          status: 62,
          ...this.orderItem
        })
          .then((res) => {
            clearTimeout(this.timer);
            if (res.code == 0) {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            } else {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.logisticsShow = false;
              this.getQueryorderorg();
            }
          })
          .catch(() => {
            clearTimeout(this.timer);
          });
      }, 200);
    },

    // 提交大使馆(isBatch=true批量提交|单个申请人提交 | payType支付方式 | userListAllTable勾选的申请人)
    confirmSubmit(isBatch, payType, userListAllTable = []) {
      if (this.submitLoading) {
        return;
      }
      this.submitLoading = true;

      // 关闭其他弹窗
      this.tjShow = false;
      this.dowmShow = false;

      let arr = [];
      if (isBatch) {
        arr = userListAllTable.map(item => item.id);
      }

      batchsubmitapplicant({
        payType,
        orderApplicantIds: arr,
      }).then((res) => {
        this.tjShow = false;
        this.submitLoading = false
        if (res.data[0].successful) {
          this.$message({
            message: "提交！",
            type: "success",
          });
          this.queryorderapplicantorgFn(
            this.orderItem.id,
            this.orderItem
          );
        } else {
          this.$message({
            message: res.data[0].msg,
            type: "warning",
          });
        }

      }).catch(() => {
        this.submitLoading = false
      });
    },
  },
};
</script>

<style lang="scss">
.order-center-page {
  .quan-dialog-out-class {
    background: none !important;
    border-radius: 12px;

    .el-dialog {
      background: none;
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      width: 419px;

      // height: 285px;
      background: linear-gradient(180deg,
          #e7ecfb 0%,
          #f6f8fe 24%,
          #ffffff 100%);
      border-radius: 12px;
      box-sizing: border-box;
      overflow: hidden;
    }
  }

  .order-center-search {
    padding: 16px;

    .el-select,
    .el-input,
    .el-input__inner {
      margin-right: 8px;
      margin-bottom: 5px;
    }

    .el-input__inner {
      background: #f2f4f7;
      border: none;
    }

    .el-table__row {
      .cell {
        font-size: 12px;
      }
    }

    .el-range-input {
      background: #f2f4f7;
    }
  }

  .el-pager {
    .active {
      cursor: default;
      background: #1492e6;
      color: #fff !important;
      border-radius: 100%;
      width: 28px;
      height: 28px;
      min-width: 10px;
      box-shadow: 0px 2px 3px 1px rgba(19, 152, 231, 0.26);
    }
  }

  .el-table__header-wrapper {
    border-radius: 8px;
  }

  .props-table-box {
    margin-top: -20px;
  }

  .props-table-box {
    // background: #F9F9F9;
    width: 100%;
    height: auto;

    .el-table__header-wrapper {
      border-radius: 0px;
    }

    .el-table__cell {
      background: #f9f9f9;
      padding: 0px;
    }

    .el-table__body {
      //-webkit-border-horizontal-spacing: 13px;  // 水平间距
      -webkit-border-vertical-spacing: 0px !important; // 垂直间距 设置的是行间距
    }

    .table-pagination {
      .el-pagination {
        height: 50px;
        margin-top: -30px;
      }
    }
  }

  .order-center-table {
    .el-table {
      .el-table__body-wrapper {
        overflow-y: auto;
      }
    }

    .el-table__row {
      box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.09);
      border-radius: 8px 8px 8px 8px;
      margin-bottom: 12px;

      .el-table__cell {
        border-bottom: none;
      }
    }

    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      height: 40px;
    }
  }

  .el-table {
    width: 100%;
    margin-bottom: 20px;

    &::before {
      display: none;
    }

    .el-table__body {
      //-webkit-border-horizontal-spacing: 13px;  // 水平间距
      -webkit-border-vertical-spacing: 10px; // 垂直间距 设置的是行间距
    }

    //以下代码是实现边框效果
    thead th {
      font-size: 14px;
      color: #575757;

      &:nth-last-child(2) {
        border-right: 1px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 0 5px 5px 0;
        right: 1px;
      }
    }

    // thead th,
    .el-table__row td {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      padding: 10px 0;
      // border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
      // border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;

      &:first-child {
        border-left: 1px solid rgba(223, 204, 204, 0.1) !important;
        border-radius: 5px 0 0 5px;
      }
    }

    .el-table__row>td {
      font-size: 12px;
      color: #333333;

      &:last-child {
        border-right: 1px solid rgba(223, 204, 204, 0.1) !important;
        border-radius: 0 5px 5px 0;
        right: 1px;
      }
    }

    // .el-table__body tr:hover>td.el-table__cell {
    //   background-color: rgba(0, 110, 255, 0.05);
    // }

    .el-table__fixed::before {
      display: none;
    }
  }
}

.el-table__expanded-cell {
  // transform: translateY(-22px) !important;
  // background: #F9F9F9;
}
</style>

<style lang="scss" scoped>
.order-center-page {
  height: 100%;
}

@media (min-width: 1280px) {
  .page-content {
    width: 80vw !important;
    max-width: 100%;
  }
}

@media (max-width: 1280px) {
  .page-content {
    width: 1200px !important;
    max-width: 100%;
  }
}

.page-content {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  height: 100%;
  display: flex;

  .order-center-search {
    width: calc(100% - 100px);
    height: calc(100% - 50px);

    .box-table {
      .el-table {
        height: 100% !important;
      }
    }
  }

  .page-menu {
    width: 150px;
    height: 50px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .page-menu-item {
      width: 100px;
      height: 50px;
      // background: #FFF;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #777777;
      background: #fff;
      cursor: pointer;
      border-radius: 8px 8px 0px 0px;
      // 超出文字隐藏显示省略号
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      box-sizing: border-box;

      &.page-menu-item-active {
        color: #3888e9;
      }
    }
  }

  .order-center-search {
    background: #fff;
    box-sizing: border-box;
    padding: 24px;

    .box-input-flex-wrap {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
    }

    .box-input-flex {
      display: flex;
      align-items: flex-start;
    }

    .button-icon {
      transform: rotate(90deg);
      width: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.quan-num-add {
  .quan-num-input {
    margin: 12px 0;
  }

  .quan-num-add-item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .quan-num-add-title {
      font-size: 16px;
      margin-top: 12px;
    }

    .quan-num-right {
      margin-left: 16px;
      color: #3888e9;
      cursor: pointer;
    }
  }
}

.dialog-member-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -10px;

  .dialog-member-name {
    font-size: 18px;
    font-weight: bold;
  }

  .dialog-close {
    width: 25px;
    height: 25px;
    background: #e0e0e0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .el-icon-close {
      color: #fff;
      font-size: 16px;
    }
  }
}

.packge-btn-add {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;

  .pageck-btn {
    width: 145px;
    margin: 0 16px;
  }
}

.edit-wrap2 {
  .edit-item {
    // padding-left: 20px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      cursor: pointer;
      display: inline-block;
      margin: 0 2px;

      &.lan {
        color: #3888e9;
      }

      &.copy {
        color: #9ea09e;
      }

      &.del {
        color: #e41313;
      }
    }
  }
}

.box-table {
  ::v-deep .el-table__expand-icon {
    width: 18px;
    height: 18px;
    background: #f2f5f9;
    border-radius: 4px;

    .el-icon {
      margin-left: -6px;
    }
  }

  .time-line {
    width: 8px;
    margin-right: 3px;
  }

  .time-text {
    height: 44px;

    p {
      text-align: left;
      line-height: 15px;
    }
  }

  .source-type {
    display: inline-block;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    background: #4791ea;
    border-radius: 4px;
    color: #fff;
    font-size: 10px;
    margin-right: 5px;
  }

  ::v-deep .cellMarks {
    .cell {
      overflow: visible;
      display: flex;
      align-items: center;
    }
  }

  .marks-line2 {
    display: -webkit-box;
    /* 将对象作为弹性伸缩盒子模型显示 */
    -webkit-box-orient: vertical;
    /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-line-clamp: 2;
    /* 限制在一个块元素显示的文本的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
  }

  .marks-line {
    display: -webkit-box;
    /* 将对象作为弹性伸缩盒子模型显示 */
    -webkit-box-orient: vertical;
    /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-line-clamp: 3;
    /* 限制在一个块元素显示的文本的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
  }

  .marks-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    width: 60px;
  }

  .overflow-ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
  }

  .marks-icon {
    position: relative;

    .marks-dialog {
      position: absolute;
      top: 27px;
      left: -190px;
      z-index: 99;
      width: 282px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      padding: 10px;

      p {
        font-size: 14px;
        font-weight: bold;
        text-align: left;
      }

      .el-textarea {
        margin-top: 20px;
      }

      ::v-deep .el-textarea__inner {
        width: 250px;
        height: 128px;
        background: #f2f4f7;
        border-radius: 8px;
        border: none;
      }

      .marks-btn {
        text-align: right;
        margin-top: 20px;

        .default {
          border-radius: 8px;
        }
      }
    }
  }

  .icon-a-xiugai1 {
    color: #3888e9;
    cursor: pointer;
    font-size: 12px;
  }

  .visa-icon {
    color: #0099e9;
    font-size: 12px;
    cursor: pointer;
  }
}

.table-pagination {
  text-align: center;
  margin-top: 10px;
}

.box-input-btn-wrap {
  // width: 130px;
  // height: 46px;
  // border-radius: 8px;
  // padding-left: 15px;
  // flex: 1;
  margin-right: 8px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  // justify-content: space-between;

  .btn-size {
    // width: 130px;
    // height: 46px;
    border-radius: 8px;
    font-size: 16px;
    box-sizing: border-box;
    padding: 12px 10px !important;

    &:nth-child(2) {
      background: #eaf3ff;
      color: #3888e9;
      border: none;
    }

    &:nth-child(3) {
      background: #fff !important;
      color: #3888e9;
      border: 1px solid #3888e9;
    }
  }
}

.edit-wrap {
  .edit-item {
    // padding-left: 20px;

    span {
      cursor: pointer;
      display: inline-block;
      margin: 0 2px;

      &.lan {
        color: #3888e9;
      }

      &.copy {
        color: #9ea09e;
      }

      &.del {
        color: #e41313;
      }
    }
  }
}
</style>
